import { memo } from 'react';
import { Breadcrumbs } from 'src/modules/common/types/Breadcrumbs';
import { Breadcrumbs as SensorsBreadcrumbs } from 'src/sensors/Breadcrumbs.ts';
import { Breadcrumbs as ActuatorsBreadcrumbs } from 'src/actuators/Breadcrumbs.ts';
import clsx from 'clsx';
import { Breadcrumb } from 'src/common/Breadcrumb/Breadcrumb.tsx';
import { BreadcrumbMobileDropdown } from 'src/common/Breadcrumb/BreadcrumbMobileDropdown.tsx';

type Props = {
    isMobile: boolean;
    breadcrumbs: Breadcrumbs | SensorsBreadcrumbs | ActuatorsBreadcrumbs;
    containerWrapperClass?: string;
}

export const BreadcrumbContainer = memo(({ isMobile, breadcrumbs, containerWrapperClass }: Props) => (
    <div
        data-testid="breadcrumb-container"
        className={clsx(
            {
                'vss-breadcrumb-container': true,
                'vss-breadcrumb-container--mobile': isMobile,
            },
            containerWrapperClass,
        )}
    >
        {isMobile ? <BreadcrumbMobileDropdown breadcrumbs={breadcrumbs}/>
            : breadcrumbs.map((breadcrumb) => (
                <Breadcrumb
                    key={breadcrumb.title}
                    {...breadcrumb}
                />
            ))}
    </div>
));
